import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
export enum ESignOutParamAction {
    CLICK = 'click',
    SESSION_EXPIRE = 'session',
}
@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.scss'],
    standalone: false
})
export class SignoutComponent implements OnInit {
    message: string;
    paramData: any;
    btnLabel: any;
    currentYear: any = new Date().getFullYear();
    constructor(
        private msalService: MsalService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            let decAto = window.atob(params.params);
            let decode = window.decodeURIComponent(decAto);
            this.paramData = JSON.parse(decode);
        });

        this.message = this.paramData.message;
        this.btnLabel = this.paramData.btnLabel;
    }
    clickToSignIn() {
        let logoutURL = this.paramData.impersonated
            ? environment.logoutRedirectURI
            : environment.redirectUri;

        this.msalService.logoutRedirect({
            postLogoutRedirectUri: logoutURL,
        });
    }
}
